import script from "./ComponenteAnalista.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponenteAnalista.vue?vue&type=script&setup=true&lang=js"

import "./ComponenteAnalista.vue?vue&type=style&index=0&id=d7e54538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7e54538"]])

export default __exports__